import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-piit-transfer-modal',
  imports: [BaseModalComponent, DatePipe, MatIconModule, TranslocoDirective],
  templateUrl: './piit-transfer-modal.component.html',
  styleUrl: './piit-transfer-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PiitTransferModalComponent {
  isOpen = input<boolean>(false);

  newServicer = input.required<string>();

  transferDate = input.required<Date>();

  loanNumber = input<string>('');

  dismiss = output<void>();

  remindLater = output<void>();

  protected onDismiss(): void {
    this.dismiss.emit();
  }

  protected onRemindLater(): void {
    this.remindLater.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.remindLater.emit();
    }
  }
}
